import { render } from "./statusChip.vue?vue&type=template&id=723635aa"
import script from "./statusChip.vue?vue&type=script&lang=js"
export * from "./statusChip.vue?vue&type=script&lang=js"

import "./statusChip.vue?vue&type=style&index=0&id=723635aa&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__